"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEbillActivated = exports.getBillingAgreementIban = exports.isDirectDebitAtMaturity = exports.debitAmountCanBeEstimated = exports.getEstimationIsFromECP = exports.getYearlyEstimationAmount = exports.getMonthlyEstimationAmount = exports.getMonthlyEstimation = exports.getUpdatedIbanStatus = exports.getBillingAgreementId = exports.getBillingAgreementFullAdresse = exports.getBillingAddress = exports.getBillingAgreementStateIban = exports.getBillingAgreementState = exports.getDirectDebitAtMaturityState = exports.getDirectDebitState = exports.getBillingAgreement = void 0;
var utils_1 = require("../helper/utils");
/**
 * Récupère le state du billing agreement
 * @param {*} store Store redux hébergeant le state
 */
function getBillingAgreement(states) {
    return states.billingAgreement.billingAgreements.data;
}
exports.getBillingAgreement = getBillingAgreement;
function getDirectDebitState(states) {
    return {
        error: states.billingAgreement.activateDirectDebit.errorMessage,
        loading: states.billingAgreement.activateDirectDebit.loading,
        success: states.billingAgreement.activateDirectDebit.active
    };
}
exports.getDirectDebitState = getDirectDebitState;
function getDirectDebitAtMaturityState(states) {
    return {
        error: states.billingAgreement.activateDirectDebitAtMaturity.errorMessage,
        loading: states.billingAgreement.activateDirectDebitAtMaturity.loading,
        success: states.billingAgreement.activateDirectDebitAtMaturity.active
    };
}
exports.getDirectDebitAtMaturityState = getDirectDebitAtMaturityState;
function getBillingAgreementState(states) {
    return states.billingAgreement;
}
exports.getBillingAgreementState = getBillingAgreementState;
function getBillingAgreementStateIban(states) {
    return states.billingAgreement.iban;
}
exports.getBillingAgreementStateIban = getBillingAgreementStateIban;
function getBillingAddress(states) {
    return states.billingAgreement.billingAddress.data;
}
exports.getBillingAddress = getBillingAddress;
//TODO get billing agreement address
/**
 * Récupère le billingAgreementFullAdresse depuis le product contract
 * @param {*} store Store redux hébergeant le state
 */
function getBillingAgreementFullAdresse(states) {
    var _a, _b, _c, _d, _e, _f, _g;
    return ("".concat((0, utils_1.getNotNullString)((_a = getBillingAddress(states)) === null || _a === void 0 ? void 0 : _a.streetAddress), " ") +
        "".concat((0, utils_1.getNotNullString)((_b = getBillingAddress(states)) === null || _b === void 0 ? void 0 : _b.addressPrecision), " ") +
        "".concat((0, utils_1.getNotNullString)((_c = getBillingAddress(states)) === null || _c === void 0 ? void 0 : _c.addressComplement), "\n") +
        "".concat((0, utils_1.getNotNullString)((_d = getBillingAddress(states)) === null || _d === void 0 ? void 0 : _d.zipCode), " ").concat((0, utils_1.getNotNullString)((_e = getBillingAddress(states)) === null || _e === void 0 ? void 0 : _e.commune), " ").concat((0, utils_1.getNotNullString)((_f = getBillingAddress(states)) === null || _f === void 0 ? void 0 : _f.cedex), " ") +
        "".concat((0, utils_1.getNotNullString)((_g = getBillingAddress(states)) === null || _g === void 0 ? void 0 : _g.city), " "));
}
exports.getBillingAgreementFullAdresse = getBillingAgreementFullAdresse;
/**
 * Récupère billingAgreementId depuis billing agreement
 * @param {*} store Store redux hébergeant le state
 */
function getBillingAgreementId(states) {
    var data = getBillingAgreement(states);
    if (data)
        return data.billingAgreementId;
    return null;
}
exports.getBillingAgreementId = getBillingAgreementId;
/**
 * Get updated iban status
 */
function getUpdatedIbanStatus(states) {
    var _a, _b;
    return (_b = (_a = states === null || states === void 0 ? void 0 : states.billingAgreement) === null || _a === void 0 ? void 0 : _a.iban) === null || _b === void 0 ? void 0 : _b.status;
}
exports.getUpdatedIbanStatus = getUpdatedIbanStatus;
/**
 * Get monthly estimate
 */
function getMonthlyEstimation(states) {
    var _a;
    return (_a = states === null || states === void 0 ? void 0 : states.billingAgreement) === null || _a === void 0 ? void 0 : _a.monthlyEstimate;
}
exports.getMonthlyEstimation = getMonthlyEstimation;
function getMonthlyEstimationAmount(states) {
    var _a, _b;
    return (_b = (_a = states === null || states === void 0 ? void 0 : states.billingAgreement) === null || _a === void 0 ? void 0 : _a.monthlyEstimate.monthlyEstimateData) === null || _b === void 0 ? void 0 : _b.monthlyEstimationAmount;
}
exports.getMonthlyEstimationAmount = getMonthlyEstimationAmount;
function getYearlyEstimationAmount(states) {
    var _a, _b;
    return (_b = (_a = states === null || states === void 0 ? void 0 : states.billingAgreement) === null || _a === void 0 ? void 0 : _a.monthlyEstimate.monthlyEstimateData) === null || _b === void 0 ? void 0 : _b.totalAmountOfCycle;
}
exports.getYearlyEstimationAmount = getYearlyEstimationAmount;
function getEstimationIsFromECP(states) {
    var _a, _b;
    return ((_b = (_a = states === null || states === void 0 ? void 0 : states.billingAgreement) === null || _a === void 0 ? void 0 : _a.monthlyEstimate.monthlyEstimateData) === null || _b === void 0 ? void 0 : _b.totalAmountOfCycle) === 0;
}
exports.getEstimationIsFromECP = getEstimationIsFromECP;
/**
 * Checks if the debit amount can be estimated
 * @param states All states available including billingAgreement
 * @returns True if debit can be estimated, false if not possible and null if object are not defined
 */
function debitAmountCanBeEstimated(states) {
    var _a, _b;
    return (((_a = states.billingAgreement) === null || _a === void 0 ? void 0 : _a.monthlyEstimate.success) &&
        !!((_b = states.billingAgreement) === null || _b === void 0 ? void 0 : _b.monthlyEstimate.monthlyEstimateData));
}
exports.debitAmountCanBeEstimated = debitAmountCanBeEstimated;
function isDirectDebitAtMaturity(states) {
    var _a, _b, _c, _d;
    return (((_b = (_a = states.billingAgreement.billingAgreements) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.paymentMethodCode) ===
        'maturity' &&
        ((_d = (_c = states.billingAgreement.billingAgreements) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.directDebit));
}
exports.isDirectDebitAtMaturity = isDirectDebitAtMaturity;
function getBillingAgreementIban(states) {
    var _a, _b;
    return (_b = (_a = states.billingAgreement) === null || _a === void 0 ? void 0 : _a.billingAgreements.data) === null || _b === void 0 ? void 0 : _b.iban;
}
exports.getBillingAgreementIban = getBillingAgreementIban;
/**
 * Checks if demat is activated for current billing aggrement
 * @param states All states available
 * @returns True is demat is activated
 */
function isEbillActivated(states) {
    var _a, _b;
    return (_b = (_a = states.billingAgreement) === null || _a === void 0 ? void 0 : _a.billingAgreements.data) === null || _b === void 0 ? void 0 : _b.dematerialization;
}
exports.isEbillActivated = isEbillActivated;
//ebillActivated
